import type { WebsiteHeaderPhotoSchema_PhotoDuoLeft } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_DUO_LEFT_DEFAULT: WebsiteHeaderPhotoSchema_PhotoDuoLeft = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoLeft-v1_1_1.json',
  presentationLayout: 'photoDuoLeft',
  photos: [],
};
